import { useRef } from 'react';
import SourcesInfiniteList from './sourceInfiniteList';
import FilterListSources from '../utils/filterLists/filterListSources';
import ListPageLayout from '../utils/ListPageLayout';

function SourcesPage() {
  const updateQueryFunc = useRef(null);

  function handleQuery(filters) {
    if (typeof updateQueryFunc.current === 'function') { updateQueryFunc.current(filters); }
  }

  return (
    <>
      <ListPageLayout
        title="Sources"
        tagline="The sources that have helped build this collection of information."
        sidebar={<FilterListSources isFiltered={handleQuery} />}
      >
        <SourcesInfiniteList filterQuery={updateQueryFunc} />
      </ListPageLayout>
    </>
  );
}

export default SourcesPage;
